import { userInfo } from '@/constants';
export default {
    getAccessToken: () => localStorage.getItem(userInfo.ACCESS_TOKEN),
    setAccessToken: (accessToken) => localStorage.setItem(userInfo.ACCESS_TOKEN, accessToken),
    removeAccessToken: () => localStorage.removeItem(userInfo.ACCESS_TOKEN),
    getSelectedHubInfo: () => {
        try {
            const hubKey = userInfo.SELECTED_HUB_INFO;
            return JSON.parse(localStorage.getItem(hubKey));
        }
        catch (error) {
            console.log('[getSelectedHubInfo] exception occur at JSON.parse');
            throw new Error(error);
        }
    },
    getSelectedSessionHubInfo: () => {
        try {
            const hubKey = userInfo.SELECTED_HUB_INFO;
            return JSON.parse(sessionStorage.getItem(hubKey));
        }
        catch (error) {
            console.log('[getSelectedSessionHubInfo]', error);
            throw new Error(error);
        }
    },
    setSelectedHubInfo: (selectedHubInfo) => {
        try {
            const hubKey = userInfo.SELECTED_HUB_INFO;
            const hubValue = JSON.stringify(selectedHubInfo);
            localStorage.setItem(hubKey, hubValue);
            sessionStorage.setItem(hubKey, hubValue);
        }
        catch (error) {
            console.log('[setSelectedHubInfo] exception occur at JSON.stringify');
            throw new Error(error);
        }
    },
    removeSelectedHubInfo: () => {
        localStorage.removeItem(userInfo.SELECTED_HUB_INFO);
        sessionStorage.removeItem(userInfo.SELECTED_HUB_INFO);
    },
    clearSessionStorage: () => sessionStorage.clear(),
    getItem: (key) => localStorage.getItem(key),
    setItem: ({ key, value }) => localStorage.setItem(key, value),
    removeItem: (key) => localStorage.removeItem(key),
    getSessionItem: (key) => sessionStorage.getItem(key),
    setSessionItem: ({ key, value }) => {
        sessionStorage.setItem(key, value);
    },
    removeSessionItem: (key) => sessionStorage.removeItem(key),
};
